module.exports = __webpack_public_path__ + "static/media/semola.89a3c61b.png";